














import { QuoteState } from '@/models/quote';

import Vue from 'vue';
export default Vue.extend({
  name: 'QuoteStatusDisplay',

  props: {
    state: { type: Number, required: true }
  },

  methods: {
    getStatusColor(state: number) {
      switch (state) {
        case QuoteState.DRAFT:
          return 'draft';

        case QuoteState.SUBMITTED:
          return 'submitted';

        case QuoteState.IN_REVIEW:
        case QuoteState.APPROVAL_2_PENDING:
        case QuoteState.APPROVAL_3_PENDING:
        case QuoteState.APPROVAL_4_PENDING:
          return 'submitted';

        case QuoteState.APPROVED:
          return 'approved';

        case QuoteState.PREPARE_FOR_CUSTOMER:
          return 'blue darken-1';

        case QuoteState.OUT_TO_CUSTOMER:
          return 'indigo lighten-1';

        case QuoteState.AWARDED:
          return 'done';

        case QuoteState.LOST:
          return 'reject';

        case QuoteState.CANCELLED:
          return 'cancel';

        case QuoteState.ORDER_CREATED:
          return 'closed';

        case QuoteState.REVIEWING_DISCOUNTS:
          return 'purple';

        case QuoteState.REVIEWING_SURCHARGES:
          return 'teal darken-2';

        default:
          return 'white';
      }
    },

    getStatusText(state: number) {
      switch (state) {
        case QuoteState.DRAFT:
          return 'Draft';

        case QuoteState.SUBMITTED:
          return 'Submitted';

        case QuoteState.IN_REVIEW:
          return 'In Review';

        case QuoteState.APPROVAL_2_PENDING:
          return 'Approval II Pending';

        case QuoteState.APPROVAL_3_PENDING:
          return 'Approval III Pending';

        case QuoteState.APPROVAL_4_PENDING:
          return 'Approval IV Pending';

        case QuoteState.APPROVED:
          return 'Approved';

        case QuoteState.PREPARE_FOR_CUSTOMER:
          return 'Ready to Share';

        case QuoteState.OUT_TO_CUSTOMER:
          return 'Out to Customer';

        case QuoteState.AWARDED:
          return 'Accepted/Order process';

        case QuoteState.LOST:
          return 'Lost';

        case QuoteState.CANCELLED:
          return 'Cancelled';

        case QuoteState.ORDER_CREATED:
          return 'Order Created';

        case QuoteState.REVIEWING_DISCOUNTS:
          return 'Reviewing Discounts';

        case QuoteState.REVIEWING_SURCHARGES:
          return 'Reviewing Surcharges';

        default:
          return 'Error';
      }
    }
  }
});
